/**
 * +/- quantity steppers on the cart page. These only adjust the number
 * input's value — the actual update still happens through the normal
 * "Update cart" form submission, so cart changes work correctly even if
 * this script fails to load.
 *
 * Also confirms before "Empty cart" navigates — it's a real link to
 * /cart/clear (works without JS), this just adds a safety prompt so a
 * misclick doesn't silently wipe a large bulk order.
 */
(function () {
  function init() {
    document.querySelectorAll('.cart-line').forEach(function (line) {
      var input = line.querySelector('.cart-qty-input');
      var decBtn = line.querySelector('[data-qty-decrease]');
      var incBtn = line.querySelector('[data-qty-increase]');
      if (!input) return;

      if (decBtn) {
        decBtn.addEventListener('click', function () {
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
        });
      }
      if (incBtn) {
        incBtn.addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 0) + 1;
        });
      }
    });

    var clearLink = document.querySelector('[data-cart-clear]');
    if (clearLink) {
      clearLink.addEventListener('click', function (e) {
        if (!window.confirm('Remove all items from your cart?')) {
          e.preventDefault();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
